<script>
import { Bus } from '../bus';

export default {
  name: 'CampaignsShow',
  props: {
    initialTab: {
      type: String,
      default: 'brief',
    },
  },
  data: () => ({
    tab: 'brief',
    joinedCampaign: false,
  }),
  computed: {},
  destroyed() {
    Bus.$off('changeCampaignTab');
  },
  mounted() {
    this.tab = this.initialTab;

    Bus.$on('changeCampaignTab', this.toggleTab);
  },
  methods: {
    toggleTab(tab) {
      this.tab = tab;
    },
    tabIs(tab) {
      return this.tab === tab;
    },
  },
};
</script>
